import { useDispatch } from "react-redux";

import { useRefineExpertsCommentaryMutation } from "@hooks/mutations/use-templates";

import { setMessage } from "@redux/notification";

import { extractRefinedText } from "../utils/extract-refined-text";

export const useRefineWording = () => {
  const dispatch = useDispatch();

  const showError = (content: string) =>
    dispatch(setMessage({ content, type: "error" }));
  const showSuccess = (content: string) =>
    dispatch(setMessage({ content, type: "success" }));

  const { mutateAsync, isPending } = useRefineExpertsCommentaryMutation({});

  const refine = async (text: string): Promise<string | null> => {
    if (!text?.trim()) {
      showError("No expert response to refine");
      return null;
    }
    try {
      const data = await mutateAsync({ originalText: text });
      const refined = extractRefinedText(
        data as Parameters<typeof extractRefinedText>[0]
      );
      if (refined === null) {
        console.warn("Unknown response format for refine experts commentary:", data);
        showError("Received unexpected response format");
        return null;
      }
      return refined;
    } catch (error) {
      console.error("Failed to refine experts commentary:", error);
      showError("Failed to refine experts commentary");
      return null;
    }
  };

  return {
    refine,
    isRefining: isPending,
    showSuccess,
    showError,
  };
};
